import { useLang } from '../context/LanguageContext';
import { useSubscriptionGate } from '../context/SubscriptionGateContext';
import { trackEvent } from '../utils/analytics';
import './SubscribePromoSection.css';

const PERKS = ['marketingPerk1', 'marketingPerk2', 'marketingPerk3', 'marketingPerk4'];

export default function SubscribePromoSection() {
  const { t } = useLang();
  const { hasFullAccess, openSubscribe } = useSubscriptionGate();

  if (hasFullAccess) return null;

  return (
    <section className="sub-promo" id="subscribe" data-sub-free aria-labelledby="sub-promo-title">
      <div className="sub-promo__card">
        <div className="sub-promo__copy">
          <span className="sub-promo__eyebrow">{t.marketingSectionEyebrow}</span>
          <h2 id="sub-promo-title" className="sub-promo__title">
            {t.marketingSectionTitle}
          </h2>
          <p className="sub-promo__lead">{t.marketingSectionLead}</p>
          <ul className="sub-promo__list">
            {PERKS.map((key) => (
              <li key={key}>{t[key]}</li>
            ))}
          </ul>
        </div>
        <div className="sub-promo__offer">
          <div className="sub-promo__price-wrap">
            <span className="sub-promo__price">₹999</span>
            <span className="sub-promo__period">/ {t.marketingPerYear}</span>
          </div>
          <p className="sub-promo__gst">{t.marketingGstNote}</p>
          <button
            type="button"
            className="sub-promo__cta"
            onClick={() => {
              trackEvent('subscribe_cta_click', { placement: 'promo_section' });
              openSubscribe();
            }}
          >
            {t.marketingSubscribeBtn}
          </button>
          <p className="sub-promo__secure">{t.marketingSecureNote}</p>
        </div>
      </div>
    </section>
  );
}
